<template>
  <div
    v-if="visible"
    class="relative inline-flex items-center space-x-2 mb-4 border border-gray-300 py-1 px-4 text-xxs text-zinc-500 bg-gray-100 rounded-full"
    v-on-clickaway="close"
  >
    <FaIcon :icon="['fas', 'bolt']" />
    <span class="font-semibold">Promoted</span>
    <button type="button" aria-label="What does Promoted mean?" @click.prevent.stop="toggle">
      <FaIcon :icon="['far', 'circle-info']" class="text-zinc-400" />
    </button>
    <div
      v-if="open"
      class="absolute bottom-full left-full mb-1 -ml-8 w-46 py-2 px-3 text-xs font-normal text-zinc-500 bg-white border border-gray-200 rounded-lg shadow-lg z-[2]"
      @click.prevent.stop
    >
      This artist paid to feature this listing
    </div>
  </div>
</template>

<script>
import Vue from "vue"

// Read lazily so experiment exposure is logged only when a boosted listing is encountered.
export const promotedLabel = Vue.observable({ enabled: false })
let promotedLabelRequested = false

function requestPromotedLabelFlag() {
  if (promotedLabelRequested) return
  promotedLabelRequested = true
  window.posthog?.onFeatureFlags(() => {
    promotedLabel.enabled = window.posthog.getFeatureFlag("promoted-label-ab") === "test"
  })
}

export default {
  name: "Listing.PromotedBadge",
  props: {
    listing: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      open: false,
      promotedLabel,
    }
  },
  mounted() {
    if (this.listing.boosted) {
      requestPromotedLabelFlag()
    }
  },
  computed: {
    visible() {
      return this.promotedLabel.enabled && this.listing.boosted && !this.listing.sold
    },
  },
  methods: {
    toggle() {
      this.open = !this.open
      if (this.open) {
        this.$emit("info-tapped")
      }
    },
    close() {
      this.open = false
    },
  },
}
</script>
